import { useAuth } from '../contexts/AuthContext';
import { getDashboardPath } from '../utils/navigationUtils';

export const useRole = () => {
    const { user } = useAuth();

    const isAdmin = user?.role === 'admin';

    const hasRole = (requiredRole: 'admin' | 'worker' | 'manager') => {
        if (!user) return false;
        
        
        return user.role === requiredRole;
    };

    const canAccessRoute = (requiredRole: 'admin' | 'worker' | 'manager') => {
        const result = hasRole(requiredRole);
        return result;
    };

    const getDashboardPathForUser = () => {
        const path = getDashboardPath(user?.role);
        return path;
    };

    return {
        user,
        isAdmin,
        hasRole,
        canAccessRoute,
        getDashboardPathForUser,
        role: user?.role
    };
};
